import {useCallback, useEffect} from 'react';

import {useFormContext} from 'react-hook-form';
import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';
import {AddressFormItemType, AddressFormType} from 'desktop/types/addressType';

import {getDeliveryStep} from '../../store/selectors/deliveryStep/deliveryStep';

export type PropsType = {
    pageType: 'new' | 'edit';
    addressType: 'shipping' | 'billing';
    deliveryStep: ApplicationStoreType['checkoutSideReview']['deliveryStep'];
};

/**
 * This component updated react-hook-form state from redux, when persisted data from localStorage received once
 */
export const EditFormFromReduxUpdater = ({addressType, deliveryStep, pageType}: PropsType) => {
    const {setValue, trigger} = useFormContext<AddressFormType>();

    // eslint-disable-next-line no-underscore-dangle
    const isRehydratedDeliveryStep = deliveryStep._persist.rehydrated;

    const setInitialValues = useCallback(() => {
        if (!deliveryStep || pageType === 'new') return;

        const data =
            addressType === 'shipping' ? deliveryStep.shippingAddress : deliveryStep.billingAddress;
        const formKey = addressType === 'shipping' ? 'shippingAddress' : 'billingAddress';

        Object.entries(data).forEach(([key, formData]) => {
            setValue(`${formKey}.${key as keyof AddressFormItemType}`, formData?.value, {
                shouldValidate: Boolean(formData?.error),
            });
        });
        // we need to trigger useEffect only when delivery step is rehydrated
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setValue, trigger, pageType, addressType, isRehydratedDeliveryStep]);

    useEffect(() => {
        setInitialValues();
    }, [setInitialValues]);

    return null;
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    deliveryStep: getDeliveryStep(store),
});

export const EditFormFromReduxUpdaterConnected = connect(mapStateToProps)(EditFormFromReduxUpdater);
